import { render, staticRenderFns } from "./CoreCarrierCards.vue?vue&type=template&id=2d4c10ec&"
import script from "./CoreCarrierCards.vue?vue&type=script&lang=js&"
export * from "./CoreCarrierCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports